import {
  GET_USAGE_HISTORY_FAILURE,
  GET_USAGE_HISTORY_REQUEST,
  GET_USAGE_HISTORY_SUCCESS,
} from "./usageHistoryTypes";  

const initialState = {
  loading: false,
  usageHistoryList: [],  
  error: "",
};

const getUsageHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USAGE_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USAGE_HISTORY_SUCCESS:
      return {
        loading: false,
        usageHistoryList: action.payload,
        error: "",
      };
    case GET_USAGE_HISTORY_FAILURE:
      return {
        loading: false,
        usageHistoryList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getUsageHistoryReducer };